"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledFoldersWrapper = exports.StyledFoldersSearchWrapper = exports.StyledFoldersHeader = exports.StyledFoldersAddIcon = exports.StyledFolders = exports.StyledFolderItemsWrapper = exports.StyledCalciteTooltipManager = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _List = _interopRequireWildcard(require("calcite-react/List"));
var _calciteComponentsReact = require("@esri/calcite-components-react");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  cursor: pointer;\n"]);
  _templateObject7 = function _templateObject7() {
    return data;
  };
  return data;
}
function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n"]);
  _templateObject6 = function _templateObject6() {
    return data;
  };
  return data;
}
function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  max-height: 10rem;\n  overflow-y: auto;\n"]);
  _templateObject5 = function _templateObject5() {
    return data;
  };
  return data;
}
function _templateObject4() {
  var data = _taggedTemplateLiteral([""]);
  _templateObject4 = function _templateObject4() {
    return data;
  };
  return data;
}
function _templateObject3() {
  var data = _taggedTemplateLiteral([""]);
  _templateObject3 = function _templateObject3() {
    return data;
  };
  return data;
}
function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  max-width: \"30rem\";\n  margin-bottom: ", ";\n"]);
  _templateObject2 = function _templateObject2() {
    return data;
  };
  return data;
}
function _templateObject() {
  var data = _taggedTemplateLiteral([""]);
  _templateObject = function _templateObject() {
    return data;
  };
  return data;
}
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var StyledFoldersWrapper = _styledComponents.default.div(_templateObject());
exports.StyledFoldersWrapper = StyledFoldersWrapper;
var StyledFolders = (0, _styledComponents.default)(_List.default)(_templateObject2(), function (_ref) {
  var marginBottom = _ref.marginBottom;
  return marginBottom ? "1rem" : "0";
});
exports.StyledFolders = StyledFolders;
var StyledFoldersHeader = (0, _styledComponents.default)(_List.ListHeader)(_templateObject3());
exports.StyledFoldersHeader = StyledFoldersHeader;
var StyledFoldersSearchWrapper = (0, _styledComponents.default)(_List.ListItem)(_templateObject4());
exports.StyledFoldersSearchWrapper = StyledFoldersSearchWrapper;
var StyledFolderItemsWrapper = _styledComponents.default.div(_templateObject5());
exports.StyledFolderItemsWrapper = StyledFolderItemsWrapper;
var StyledCalciteTooltipManager = (0, _styledComponents.default)(_calciteComponentsReact.CalciteTooltipManager)(_templateObject6());
exports.StyledCalciteTooltipManager = StyledCalciteTooltipManager;
var StyledFoldersAddIcon = (0, _styledComponents.default)(_calciteComponentsReact.CalciteIcon)(_templateObject7());
exports.StyledFoldersAddIcon = StyledFoldersAddIcon;